import { render, staticRenderFns } from "./drugRemoveModal.vue?vue&type=template&id=6658e7fe&scoped=true"
import script from "./drugRemoveModal.vue?vue&type=script&lang=js"
export * from "./drugRemoveModal.vue?vue&type=script&lang=js"
import style0 from "./drugRemoveModal.vue?vue&type=style&index=0&id=6658e7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6658e7fe",
  null
  
)

export default component.exports